import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const emptyRecord = {
    amt: null,
    compoundtype: null,
    effectiveMonth: null
  }
  const _data = (rowData) => ({
    ...rowData[props.field],
    amt: rowData.amt,
    compoundtype: rowData.compoundtype
  })
  const [data, setData] = useState<object|null>(_data(props.rowData));

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    if (!nextData['compoundtype']) nextData['compoundtype'] = compoundTypeDefault
    if (!nextData['effectiveMonth']) nextData['effectiveMonth'] = 'Market Effective Month'
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'inflationdetail', props.rowData)
  }

  const attrs = (field) => field_attrs('inflation', props.field)(field)(props.rowData, props)
  const unnested_attrs = (field) => field_attrs('inflation')(field)(props.rowData, props)
  const compoundTypeDefault = props.defaults['inflationCompoundType'];

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput className="automated" data={data} attrs={unnested_attrs} field="amt" readPrecision={4} writePrecision={4} min={-100} max={100} persist={updateData} />
        </div>
        <div>
          <label>Compound Type</label>
          <DropdownInput className="automated" data={data} attrs={unnested_attrs} default={compoundTypeDefault} field="compoundtype" options={['Annual', 'Monthly']} persist={updateData} />
        </div>
        <div>
          <label>Effective Month</label>
          <DropdownInput className="automated" data={data} default="Market Effective Month" attrs={attrs} field="effectiveMonth" options={['Market Effective Month', 'Recovery Effective Month', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic
